/** Display helpers for warehouse roster cells. Formatting is not a truth claim. */

export const EM_DASH = '\u2014';

export function textOrDash(value: string | number | null): string {
  if (value === null) return EM_DASH;
  return String(value);
}

export function joinOrDash(values: readonly (string | null)[]): string {
  const parts: string[] = [];
  for (const value of values) {
    if (value !== null && value.length > 0) parts.push(value);
  }
  return parts.length === 0 ? EM_DASH : parts.join(', ');
}

export function moneyOrDash(amount: number | null, currency: string | null): string {
  if (amount === null && currency === null) return EM_DASH;
  if (amount === null) return currency ?? EM_DASH;
  if (currency === null) return String(amount);
  return `${amount} ${currency}`;
}

export function boolLabel(value: boolean, yes: string, no: string): string {
  return value ? yes : no;
}

export function nullableBoolLabel(value: boolean | null, yes: string, no: string): string {
  if (value === null) return EM_DASH;
  return boolLabel(value, yes, no);
}

/**
 * Format a warehouse date/time string with `Intl.DateTimeFormat` in `locale`.
 * `YYYY-MM-DD` is date-only (local calendar, no UTC shift). Strings that include
 * a time are date+time. Unparseable values are shown as sent.
 */
export function formatWarehouseDateTime(value: string | null, locale: string): string {
  if (value === null) return EM_DASH;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const year = Number(value.slice(0, 4));
    const month = Number(value.slice(5, 7));
    const day = Number(value.slice(8, 10));
    return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(
      new Date(year, month - 1, day),
    );
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(parsed);
}
